// src/main.js

import _ from 'lodash';
import $ from 'jquery';
import axios from 'axios';
import moment from 'moment-timezone';
import { createApp } from 'vue';
import { createStore } from 'vuex';
import RuntimeTemplate from 'vue3-runtime-template';

// Ensure global context exists before importing UMD modules
if (typeof window === 'undefined') {
  globalThis.window = globalThis;
}
if (typeof global === 'undefined') {
  globalThis.global = globalThis;
}

// Set up a safe root object for UMD modules
globalThis.root = globalThis;


import { motion } from 'motion-v'
import { AnimatePresence } from 'motion-v'
import LangJs from './../Library/LangJs/Lang.js';
import messages from '../lang/messages.json';



// Ensure window and appSettings exist with fallback values
if (typeof window !== 'undefined') {
  window.appSettings = window.appSettings || {
    appLanguage: 'en',
    appLanguageFallback: 'en'
  };
} else {
  // Create a global object if window doesn't exist
  global.window = global.window || {
    appSettings: {
      appLanguage: 'en',
      appLanguageFallback: 'en'
    }
  };
}

// Components
/*import GlobalLoader from '../components/public/conference/Global-Loader.vue';
import UpCounter from './widgets/UpCounter.vue';
import EventDetailBooking from './widgets/EventDetailBooking.vue';
import EventCalendar from './widgets/EventCalendar.vue';
import ScheduleExtended from './widgets/schedule_browser/src/App.vue';
import EventsBrowser from './widgets/events-browser/src/App.vue';
;*/

// ——————————————————————————————————————————————
// 1. Set up globals
// ——————————————————————————————————————————————
import CustomPluginElement from './Components/CustomPluginElement.vue';
import CustomRuntimeTemplate from './Components/CustomRuntimeTemplate.vue';
import GlobalLoader from '../Components/Global-Loader.vue'
import EventSchedule from './EventSchedule/EventSchedule.vue';
import EventCalendar from './Components/EventCalendar.vue';
import EventsBrowser from './EventBrowser/EventBrowser.vue';
import AnimatedLogoCloud from './Components/AnimatedLogoCloud.vue';
window._       = _;
window.$       = $;
window.axios   = axios;
window.moment  = moment;

window.Lang = new LangJs({
    locale:window.appSettings.appLanguage,
    fallback:window.appSettings.appLanguageFallback,
    messages: messages
});



axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status) {
      if ([401, 403].includes(error.response.status)) {
        // redirect if you like…
      } else {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

moment.locale(window.appSettings.appLanguage);
moment.tz.setDefault('Europe/Berlin');

// ——————————————————————————————————————————————
// 2. Vuex store (chatStore ported unchanged)
// ——————————————————————————————————————————————

import store from './store'

// ——————————————————————————————————————————————
// 3. Create & mount main app
// ——————————————————————————————————————————————

const mainApp = createApp({
  data() {
    return {
      temp: {},
      globalLoading: false
    };
  },
  methods: {
    setVariable(name, value) {
      this[name] = value;
    },
    getVariable(name) {
      return this[name] ?? false;
    }
  }
});

mainApp.use(store);
mainApp.use(RuntimeTemplate);

/*
mainApp.component('up-counter', UpCounter);
mainApp.component('event-detail-booking', EventDetailBooking);
mainApp.component('event-calendar', EventCalendar);

mainApp.component('events-browser', EventsBrowser);*/
mainApp.component('custom-plugin-element', CustomPluginElement);
mainApp.component('custom-runtime-template', CustomRuntimeTemplate);
mainApp.component('global-loader', GlobalLoader);
mainApp.component('schedule-extended', EventSchedule);
mainApp.component('event-calendar', EventCalendar);
mainApp.component('events-browser', EventsBrowser);
mainApp.component('exhibitor-cloud', AnimatedLogoCloud);
mainApp.config.globalProperties.$       = $;
mainApp.config.globalProperties._       = _;
mainApp.config.globalProperties.$axios  = axios;
mainApp.config.globalProperties.$moment = moment;

mainApp.mixin({
  methods: {
    getDateObject(dateString) {
      return window.moment(dateString);
    },
    trimHtmlField(str) {
      if (!str) return false;
      const cleaned = String(str).replace(/<[^>]*>/g, '').trim();
      return cleaned !== '';
    },
    translate(translateString) {

      let translation = window.Lang.get(translateString)
      if(!translation){
          
      }

      return translation ?? translateString
  },
    translateField(data) {
      const lang = window.appSettings.appLanguage;
      if (!data) return '';
      if (typeof data[lang] !== 'undefined') return data[lang];
      if (typeof data['A0']   !== 'undefined') return data['A0'];
      return typeof data !== 'object' ? data : '';
    },
    translate(key) {
      return window.Lang.get(key) ?? key;
    },
    getObjectLength(obj) {
      return _.keys(obj).length;
    }
  }
});

mainApp.component('motion', motion);
mainApp.component('motion.div', motion.div);
mainApp.component('motion.li', motion.li);

mainApp.component('AnimatePresence', AnimatePresence);

mainApp.mount('#crm__widgets');
// ——————————————————————————————————————————————
// 4. Create & mount widgets-only app
// ——————————————————————————————————————————————

const widgetsApp = createApp({
  //components: { ICountUp: UpCounter },
  data() {
    return {
      temp: {},
      globalLoading: false
    };
  },
  methods: {
    setVariable(name, value) {
      this[name] = value;
    },
    getVariable(name) {
      return this[name] ?? false;
    }
  }
});

widgetsApp.component('custom-runtime-template', CustomRuntimeTemplate);


